module.exports = __webpack_public_path__ + "img/contact-bg-01.a446c7f0.jpg";